import React from 'react';

import MobileDataTableCard from '../../../../../DataTables/MobileDataTableCard';
import AdvancedDataTable from '../../../../../DataTables/AdvancedDataTable';

export default function RunningBackCollegeAdvancedRushingStatsTable(props) {
	return (
		<div>
			<div className="text-xl py-2">
				<h4>{props.title}</h4>
			</div>
			<div className="contents lg:hidden">
				<MobileDataTableCard
					data={props.data}
					style="text-gray-800 dark:text-dark-text border-b border-gray-300 dark:border-dark-border font-semibold"
					rowRenderer={(row) => {
						const labels = [
							{
								displayName: 'Category',
								apiName: 'category',
								alignment: 'left'
							},
							{
								displayName: 'Rush Attempts Per Game',
								apiName: 'college_rush_attempts_per_game',
								alignment: 'left',
								helper_text: 'The average rush attempts per game.'
							},
							{
								displayName: 'Rushing Yards Per Game',
								apiName: 'college_rushing_yards_per_game',
								alignment: 'left',
								helper_text: 'The average rushing yards per game.'
							},
							{
								displayName: 'Rushing TDs Per Game',
								apiName: 'college_rushing_touchdowns_per_game',
								alignment: 'left',
								helper_text: 'The average rushing touchdowns per game.'
							},
							{
								displayName: 'Rush Attempts Per TD',
								apiName: 'college_rush_attempts_per_touchdown',
								alignment: 'left',
								helper_text: 'The average rush attempts per touchdown.'
							},
							{
								displayName: 'Rushing Yards Per TD',
								apiName: 'college_rushing_yards_per_touchdown',
								alignment: 'left',
								helper_text: 'The average rushing yards per touchdown.'
							}
						];
						return (
							<div
								key={`${row.first_name} ${row.last_name} - PlayersProfileStatsTable - MobileDataTableCard`}
								className="p-5 bg-white dark:bg-dark-card border-t border-gray-200 dark:border-dark-border text-gray-800 dark:text-dark-text"
							>
								<div className="flex flex-wrap">
									<div
										className="w-1/2 font-semibold"
										style={{ minWidth: '175px' }}
									>
										{labels[1].displayName}
									</div>
									<div className="w-1/2 mb-2">
										{row.college_rush_attempts_per_game}
									</div>
									<div
										className="w-1/2 font-semibold"
										style={{ minWidth: '175px' }}
									>
										{labels[2].displayName}
									</div>
									<div className="w-1/2 mb-2">
										{row.college_rushing_yards_per_game}
									</div>
									<div
										className="w-1/2 font-semibold"
										style={{ minWidth: '175px' }}
									>
										{labels[3].displayName}
									</div>
									<div className="w-1/2 mb-2">
										{row.college_rushing_touchdowns_per_game}
									</div>
									<div
										className="w-1/2 font-semibold"
										style={{ minWidth: '175px' }}
									>
										{labels[4].displayName}
									</div>
									<div className="w-1/2 mb-2">
										{row.college_rush_attempts_per_touchdown}
									</div>
									<div
										className="w-1/2 font-semibold"
										style={{ minWidth: '175px' }}
									>
										{labels[5].displayName}
									</div>
									<div className="w-1/2">
										{row.college_rushing_yards_per_touchdown}
									</div>
								</div>
							</div>
						);
					}}
				/>
			</div>
			<div className="hidden lg:contents">
				<AdvancedDataTable
					data={props.data}
					style="text-gray-800 dark:text-dark-text border-b border-gray-300 dark:border-dark-border font-semibold"
					columns={[
						{
							displayName: 'Category',
							apiName: 'category',
							alignment: 'left'
						},
						{
							displayName: 'Rush Attempts Per Game',
							apiName: 'college_rush_attempts_per_game',
							alignment: 'left',
							helper_text: 'The average rush attempts per game.'
						},
						{
							displayName: 'Rushing Yards Per Game',
							apiName: 'college_rushing_yards_per_game',
							alignment: 'left',
							helper_text: 'The average rushing yards per game.'
						},
						{
							displayName: 'Rushing TDs Per Game',
							apiName: 'college_rushing_touchdowns_per_game',
							alignment: 'left',
							helper_text: 'The average rushing touchdowns per game.'
						},
						{
							displayName: 'Rush Attempts Per TD',
							apiName: 'college_rush_attempts_per_touchdown',
							alignment: 'left',
							helper_text: 'The average rush attempts per touchdown.'
						},
						{
							displayName: 'Rushing Yards Per TD',
							apiName: 'college_rushing_yards_per_touchdown',
							alignment: 'left',
							helper_text: 'The average rushing yards per touchdown.'
						}
					]}
					rowRenderer={(row) => {
						return (
							<tr key={row.id} className="bg-white dark:bg-dark-card border-t border-gray-200 dark:border-dark-border text-gray-800 dark:text-dark-text">
								<td className="pl-8 py-3 text-left sticky left-0 bg-white dark:bg-dark-card z-10 text-gray-800 dark:text-dark-text">
									Career
								</td>
								<td className="pl-8 py-3 text-left">
									{row.college_rush_attempts_per_game}
								</td>
								<td className="pl-8 py-3 text-left">
									{row.college_rushing_yards_per_game}
								</td>
								<td className="pl-8 py-3 text-left">
									{row.college_rushing_touchdowns_per_game}
								</td>
								<td className="pl-8 py-3 text-left">
									{row.college_rush_attempts_per_touchdown}
								</td>
								<td className="pl-8 py-3 text-left">
									{row.college_rushing_yards_per_touchdown}
								</td>
							</tr>
						);
					}}
				/>
			</div>
		</div>
	);
}
